import { AxiosInstance } from "axios";
import {
  TDeerFlowInstanceAgent,
  TDeerFlowInstanceAgents,
  TDeerFlowThread,
  TDeerFlowThreads,
  TDerrFlowDeleteThreadResponse,
} from "./types";
import { DEERFLOW_THREADS_REQUEST_OBJECT } from "../../../../features/DeerFlow/constants";
import { convertMessages } from "../../../../features/DeerFlow/utils/convertMessages";
import { ChatCompletionsMessageObject } from "../completionsApi/types";
import { multiUserApi } from "../../../../shared/utils/multiUserFunctions";
import { threadId } from "worker_threads";
import { generateId } from "../../../../shared/utils/generateId";

export const deerFlowApi = {
  getFlowsAgent: (api: AxiosInstance): Promise<TDeerFlowInstanceAgents> =>
    api.get("/api/agents").then((res) => {
      return res.data;
    }),

  getFlowAgentChat: (
    api: AxiosInstance,
    name: string,
  ): Promise<TDeerFlowInstanceAgent> =>
    api.get(`/api/agents/${name}`).then((res) => res.data),

  getFlowInstanceThreads: (api: AxiosInstance): Promise<TDeerFlowThreads> =>
    api
      .post(`/api/langgraph/threads/search`, DEERFLOW_THREADS_REQUEST_OBJECT)
      .then((res) => res.data),

  createFlowInstanceThreads: (
    api: AxiosInstance,
    agentName: string,
  ): Promise<TDeerFlowThread> =>
    api
      .post(`/api/langgraph/threads`, {
        metadata: { agent_name: agentName },
        thread_id: generateId(),
      })
      .then((res) => res.data),

  deleteFlowInstanceThreads: (
    api: AxiosInstance,
    threadId: string,
  ): Promise<TDerrFlowDeleteThreadResponse> =>
    api.delete(`/api/langgraph/threads/${threadId}`).then((res) => res.data),

  getFlowInstanceMessages: (
    api: AxiosInstance,
    threadId: string,
  ): Promise<ChatCompletionsMessageObject[]> =>
    api
      .post(`/api/langgraph/threads/${threadId}/history`, { limit: 1 })
      .then((res) => convertMessages(res.data[0].values.messages)),

  sendMessage: async (api: AxiosInstance, text: string, threadId: string) => {
    const keycloakToken = multiUserApi.getUserKey("access_token");
    const baseUrl = api.getUri();
    const response = await fetch(
      `${baseUrl}/api/langgraph/threads/${threadId}/runs/stream`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(keycloakToken && { "X-Keycloak-Token": keycloakToken }),
        },
        body: JSON.stringify({
          input: {
            messages: [
              {
                type: "human",
                content: [{ type: "text", text }],
                additional_kwargs: {},
              },
            ],
          },
          config: { recursion_limit: 1000 },
          context: {
            model_name: "deerflow-auto",
            mode: "flash",
            thinking_enabled: false,
            is_plan_mode: false,
            subagent_enabled: false,
            thread_id: threadId,
          },
          stream_mode: [
            "messages-tuple",
            "values",
            "updates",
            "custom",
            "events",
          ],
          stream_subgraphs: true,
          stream_resumable: true,
          assistant_id: "lead_agent",
          on_disconnect: "continue",
        }),
      },
    );
    console.log("STREAM", response.body);
    if (!response.body) return;
    const reader = response?.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";
    let fullMessage = "";

    console.log("Reader", reader);
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split("\n");
      buffer = lines.pop() ?? "";

      for (const line of lines) {
        if (line === "event: end") {
          reader.cancel();
          return fullMessage;
        }

        if (!line.startsWith("data: ")) continue;

        try {
          const parsed = JSON.parse(line.slice(6));
          const chunk = parsed[0];
          if (chunk?.type === "AIMessageChunk" && chunk?.content) {
            fullMessage += chunk.content;
          }
        } catch (e) {}
      }
    }

    return fullMessage;
  },
};
